import React from "react";
import "./Mid.css";

export default function Mid() {
  const features = [
    {
      icon: "git-network-outline",
      title: "Emergency Care",
      desc: "Rapid response medical teams available 24/7",
    },
    {
      icon: "time-outline",
      title: "24 hrs Service",
      desc: "Round-the-clock healthcare, every day of the year",
    },
    {
      icon: "medical-outline",
      title: "Qualified Doctors",
      desc: "Board-certified specialists with global experience",
    },
    {
      icon: "home-outline",
      title: "Home Visits",
      desc: "Expert care delivered straight to your door",
    },
  ];

  return (
    <section className="mid-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Headline */}
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <h4 className="mid-headline" data-aos="fade-right">
              Revolutionising access to medical doctor services through
              homestead and community-based approaches
            </h4>
          </div>

          {/* Features */}
          <div className="col-lg-8 col-md-12">
            <div className="features-grid" data-aos="fade-left">
              {features.map((f, i) => (
                <div className="feature-item" key={i}>
                  <span className="feature-icon">
                    <ion-icon name={f.icon}></ion-icon>
                  </span>
                  <div className="feature-title">{f.title}</div>
                  <p className="feature-desc">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
